<script setup lang="ts">
interface Props {
  modelValue: boolean
  label?: string
  disabled?: boolean
}

interface Emits {
  (e: 'update:modelValue', value: boolean): void
}

withDefaults(defineProps<Props>(), {
  label: '',
  disabled: false,
})

defineEmits<Emits>()
</script>

<template>
  <v-checkbox
    :model-value="modelValue"
    :label="label"
    :disabled="disabled"
    @update:model-value="(v) => $emit('update:modelValue', v ?? false)"
  />
</template>

<style scoped lang="scss">
</style>
